import { IconCheckDefault } from '@iwoca/icons';
import { Card, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const CashlessProductExplanation = () => {
    return (
        <Card className="space-y-xl p-xl">
            <Text className="text-xl font-bold">
                <FormattedMessage
                    id="_.rcf_approved_view.cashless.product_explanation_title"
                    defaultMessage="Here's how it works:"
                />
            </Text>
            <div className="space-y-m">
                <div className="flex flex-row gap-s">
                    <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                    <div>
                        <Text className="font-med">
                            <FormattedMessage
                                id="_.rcf_approved_view.cashless.product_explanation_bullet_1"
                                defaultMessage="Activate Today"
                            />
                        </Text>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.rcf_approved_view.cashless.product_explanation_bullet_1_subtext"
                                defaultMessage="Get access to the full credit line for 12 months."
                            />
                        </Text>
                    </div>
                </div>
                <div className="flex flex-row gap-s">
                    <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                    <div>
                        <Text className="font-med">
                            <FormattedMessage
                                id="_.rcf_approved_view.cashless.product_explanation_bullet_2"
                                defaultMessage="Withdraw money at any time"
                            />
                        </Text>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.rcf_approved_view.cashless.product_explanation_bullet_2_subtext"
                                defaultMessage="No need to reapply. Interest only accrues when you withdraw money."
                            />
                        </Text>
                    </div>
                </div>
                <div className="flex flex-row gap-s">
                    <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                    <div>
                        <Text className="font-med">
                            <FormattedMessage
                                id="_.rcf_approved_view.cashless.product_explanation_bullet_3"
                                defaultMessage="Repay Flexibly"
                            />
                        </Text>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.rcf_approved_view.cashless.product_explanation_bullet_3_subtext"
                                defaultMessage="Over the 12 months, you only pay the interest accrued monthly. You can repay the outstanding amount at any time for free, saving on interest."
                            />
                        </Text>
                    </div>
                </div>
                <div className="flex flex-row gap-s">
                    <IconCheckDefault className="size-[20px] shrink-0 fill-success-mid" />
                    <div>
                        <Text className="font-med">
                            <FormattedMessage
                                id="_.rcf_approved_view.cashless.product_explanation_bullet_4"
                                defaultMessage="Extension possible after a new credit check."
                            />
                        </Text>
                        <Text className="text-s">
                            <FormattedMessage
                                id="_.rcf_approved_view.cashless.product_explanation_bullet_4_subtext"
                                defaultMessage="The interest-free period can be terminated by either party from the 3rd month. You will then repay the outstanding loan amount in 12 monthly installments."
                            />
                        </Text>
                    </div>
                </div>
            </div>
        </Card>
    );
};
